import {
  required,
  email,
  confirmed,
  min,
  min_value,
} from "vee-validate/dist/rules"
import { extend } from "vee-validate"

extend("required", {
  ...required,
  message: "Este campo é obrigatório",
})

extend("email", {
  ...email,
  message: "Este campo deve ser um email válido",
})

extend("confSenha", {
  ...confirmed,
  message: "A senha e a confirmação de senha estão diferentes",
})

extend("min", {
  ...min,
  message: "Este campo deve ter no mínimo {length} caracteres",
})

extend("min_andar", {
  ...min_value,
  message: "Um bloco deve ter pelo menos 1 andar",
})

extend("min_capacidade", {
  ...min_value,
  message: "Uma sala deve comportar pelo menos uma pessoa",
})
